<div class="document-form-container" *ngIf="vm$ | async as vm">
  <div fxLayout="row" fxLayoutAlign="space-between">
    <fsx-basic-single-selection
      #documentTypeField
      [caption]="'Document Type'"
      [helpText]="''"
      [hint]="''"
      [fieldType]="fieldType.Selection"
      [width]="'480px'"
      [selectionType]="selectionType"
      [required]="true"
      [disabled]="vm.disabled"
      [inputDropdownOptions]="documentTypeList"
      [initialValue]="documentsGridRow.requestDocument.category?.name"
      (selectedValue)="
        onDocumentTypeSelected({
          value: $event,
          requestDocument: documentsGridRow.requestDocument,
          documentIndex: documentsGridRow.rowIndex,
        })
      "
    >
    </fsx-basic-single-selection>
    <div *ngIf="!accessTypeFieldDefinition" style="width: 162px"></div>
    <fsx-basic-single-selection
      *ngIf="accessTypeFieldDefinition"
      #accessTypeField
      [caption]="'Access Type'"
      [helpText]="''"
      [hint]="''"
      [fieldType]="fieldType.Selection"
      [width]="'162px'"
      [selectionType]="selectionType"
      [required]="true"
      [disabled]="vm.disabled"
      [inputDropdownOptions]="accessTypeList"
      [initialValue]="documentsGridRow.requestDocument.accessCategoryName"
      (selectedValue)="
        onAccessTypeSelected({
          value: $event,
          requestDocument: documentsGridRow.requestDocument,
          documentIndex: documentsGridRow.rowIndex,
        })
      "
    >
    </fsx-basic-single-selection>
  </div>
  <div>
    <fsx-text-component
      #documentTitleField
      cdkDragDisabled="true"
      [caption]="'Document Title'"
      [fieldDefinition]="documentTitleFieldDefinition"
      [initialValue]="documentsGridRow.requestDocument.title"
      [width]="'100%'"
      [resolver]="resolver"
      [disabled]="vm.disabled"
      (textChanged)="
        onDocumentTitleTextChanged({
          value: $event,
          requestDocument: documentsGridRow.requestDocument,
          documentIndex: documentsGridRow.rowIndex,
        })
      "
    >
    </fsx-text-component>
  </div>
  <div>
    <fsx-text-component
      #fileNameField
      cdkDragDisabled="true"
      [caption]="'File Name'"
      [fieldDefinition]="fileNameFieldDefinition"
      [initialValue]="documentsGridRow.requestDocument.fileName"
      [width]="'100%'"
      [resolver]="resolver"
      [disabled]="vm.disabled"
      (textChanged)="
        onFileNameTextChanged({
          value: $event,
          requestDocument: documentsGridRow.requestDocument,
          documentIndex: documentsGridRow.rowIndex,
        })
      "
    >
    </fsx-text-component>
  </div>

  <div
    id="add-associated-party-row"
    *ngIf="
      documentsGridRow.requestDocument.category?.name &&
      (vm.asToVm.participantFieldSpec || vm.filedByVm.participantFieldSpec)
    "
  >
    <fsx-row-validation
      [isValid]="vm.associatedPartyValidationErrors.length === 0"
      [cssClass]="'margin-right'"
    >
    </fsx-row-validation>

    <button
      id="add-associated-party-button"
      (click)="onAddAssociatedPartyClicked()"
      *ngIf="
        !isAddingAssociatedParty &&
          !vm.filedByVm.hasParticipants &&
          !vm.asToVm.hasParticipants;
        else searchForParty
      "
      fxLayout="row"
      fxFlex="nogrow"
      fxLayoutAlign="start center"
    >
      <span class="material-icons add-icon"> add_circle </span>
      Associated Party
    </button>

    <ng-template #searchForParty>
      <div fxLayout="column">
        <h4 id="associated-party-heading">Associated Party</h4>
        <!-- START: FiledBy Associated Party (If allowed) -->
        <fsx-participant-field
          #filedByField
          *ngIf="
            documentsGridRow.requestDocument.category?.name &&
            vm.filedByVm.participantFieldSpec
          "
          [additionalFieldValues]="
            associatedPartyFiledBy
              ? associatedPartyFiledBy.additionalFieldValues!
              : []
          "
          [participantFieldSpec]="vm.filedByVm.participantFieldSpec"
          [targetRequestDocumentParticipant]="associatedPartyFiledBy"
          [combinedFilingData]="combinedFilingData"
          [inputDropdownOptions]="vm.filedByVm.dropdownOptions"
          [resolver]="resolver"
          [caption]="'Filed By'"
          [documentsGridRow]="documentsGridRow"
          [selectedParticipants]="vm.filedByVm.selectedParticipants"
          [width]="'300px'"
          [fileUploadDocumentInfos]="filedByFileUploadDocumentInfos"
          (additionalFieldValuesEvent)="
            filedByAdditionalFieldValueEventHandler($event)
          "
          (removeParticipantEvent)="
            onFiledByRemoved({
              selectedParticipant: $event,
              requestDocument: documentsGridRow.requestDocument,
              documentIndex: documentsGridRow.rowIndex,
            })
          "
          (selectParticipantEvent)="
            onFiledBySelected({
              selectedParticipant: $event,
              requestDocument: documentsGridRow.requestDocument,
            })
          "
          (filesUploadedFromAdditionalFieldEvent)="
            filesUploadedFromFiledByAdditionalFieldEventHandler($event)
          "
          (fileRemovedFromAdditionalFieldEvent)="
            fileRemovedFromFiledByAdditionalFieldEventHandler($event)
          "
        >
        </fsx-participant-field>
        <!-- END: FiledBy Associated Party -->

        <!-- START: AsTo Associated Party (If allowed) -->
        <fsx-participant-field
          #asToField
          *ngIf="
            documentsGridRow.requestDocument.category?.name &&
            vm.asToVm.participantFieldSpec
          "
          [additionalFieldValues]="
            associatedPartyAsTo
              ? associatedPartyAsTo.additionalFieldValues!
              : []
          "
          [participantFieldSpec]="vm.asToVm.participantFieldSpec"
          [targetRequestDocumentParticipant]="associatedPartyAsTo"
          [combinedFilingData]="combinedFilingData"
          [inputDropdownOptions]="vm.asToVm.dropdownOptions"
          [caption]="'As To'"
          [width]="'300px'"
          [documentsGridRow]="documentsGridRow"
          [selectedParticipants]="vm.asToVm.selectedParticipants"
          [resolver]="resolver"
          [fileUploadDocumentInfos]="asToFileUploadDocumentInfos"
          (additionalFieldValuesEvent)="
            asToAdditionalFieldValueEventHandler($event)
          "
          (removeParticipantEvent)="
            onAsToRemoved({
              selectedParticipant: $event,
              requestDocument: documentsGridRow.requestDocument,
              documentIndex: documentsGridRow.rowIndex,
            })
          "
          (selectParticipantEvent)="
            onAsToSelected({
              selectedParticipant: $event,
              requestDocument: documentsGridRow.requestDocument,
            })
          "
          (filesUploadedFromAdditionalFieldEvent)="
            filesUploadedFromAsToAdditionalFieldEventHandler($event)
          "
          (fileRemovedFromAdditionalFieldEvent)="
            fileRemovedFromAsToAdditionalFieldEventHandler($event)
          "
        >
        </fsx-participant-field>
        <!-- END: AsTo Associated Party -->
      </div>
    </ng-template>
  </div>
  <div class="additional-fields-container" *ngIf="true">
    <fsx-additional-fields-container
      [additionalFieldSpecs]="vm.additionalFieldSpecs!"
      [additionalFieldValues]="documentCaseAdditionalFieldValues"
      [resolver]="resolver"
      (additionalFieldValuesEvent)="
        onAdditionalFieldValuesEmitted($event, documentsGridRow)
      "
    >
    </fsx-additional-fields-container>
  </div>
</div>
